var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPressureVeryLow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 24,
    viewBox: "0 0 31 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.561 12.2151C17.3254 12.2151 18.7556 13.6454 18.7556 15.4097C18.7556 17.174 17.3254 18.6043 15.561 18.6043C13.7967 18.6043 0.366455 15.4097 0.366455 15.4097C0.366455 15.4097 13.7967 12.2151 15.561 12.2151Z",
    fill: "#FF7A00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0743 23.1818C29.6085 20.8288 30.5001 18.0185 30.5001 15V14.9982C30.5001 7.51505 25.0205 1.31175 17.8549 0.181944L17.8551 0.183801C17.0879 0.0628193 16.3013 0 15.5001 0C14.7032 0 13.9208 0.0621438 13.1575 0.18185L13.1578 0.179993C6.63205 1.20329 1.50206 6.43395 0.630859 13.0089L2.96286 12.685C3.25418 11.1327 3.82665 9.67962 4.62539 8.38052L4.62474 8.37967C5.57747 6.82981 6.85222 5.49914 8.35579 4.48087L8.35708 4.48185C10.3952 3.10194 12.8535 2.29596 15.5001 2.29596C22.3981 2.29596 28.0173 7.77094 28.2493 14.6124C28.2542 14.7579 28.2566 14.904 28.2566 15.0507C28.2566 17.5053 27.5634 19.7979 26.362 21.7435H4.63813C3.95901 20.6437 3.44226 19.4329 3.12132 18.1447L0.763628 17.8139C1.13355 19.763 1.88058 21.5786 2.92594 23.1818C3.26949 23.7087 3.8691 24 4.49811 24H26.5021C27.1311 24 27.7307 23.7087 28.0743 23.1818Z",
    fill: "white",
    fillOpacity: 0.87
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPressureVeryLow);
export default __webpack_public_path__ + "static/media/pressure_very_low.3c289556dab7a2535f7748b2e4312c8e.svg";
export { ForwardRef as ReactComponent };